/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
var ToolbarContext = createContext();
export default ToolbarContext;
//# sourceMappingURL=index.js.map